import React from 'react';
import INCSUBButton from '../components/common/Button/INCSUBButton';
import { useNavigate } from 'react-router';
import './styleHomeScreen.css';

/**
 * INCSUBHomeScreen Component
 * 
 * This component displays a simple landing screen with a "Sign In" button.
 * It checks if user data exists in localStorage to determine whether to navigate
 * to the login page or the appropriate dashboard based on user role.
 * 
 * @returns {JSX.Element} A styled homepage with logo and a sign-in action.
 */
function INCSUBHomeScreen() {
    const navigate = useNavigate();

    // Retrieve user data from local storage
    const userData = window.localStorage.getItem("userData");

    /**
     * Handles login button click.
     * Navigates to the login page if user data is missing or null,
     * otherwise navigates to the user's role-based dashboard.
     */
    const handleLogin = () => {
        if (!userData || userData === 'null') {
            // Redirect to login if user is not authenticated
            navigate('/login');
            return;
        }

        // Navigate to dashboard based on user role
        const userRole = JSON.parse(userData).userRole;
        navigate(`/${userRole}`);
    };

    return (
        <div className='INCSUBHomescreen'>
            <div className='INCSUBHomescreen_container'>
                <div className='INCSUBHomescreen_info_container'>
                    {/* Logo */}
                    <div className='INCSUBHomescreen_logo_container'>
                        <img src='/assets/images/navbar/full_logo.png' alt='INCSUB Logo' />
                    </div>

                    {/* Text info */}
                    <div className='INCSUBHomescreen_text_info'>
                        <h1>Go to Dashboard</h1>
                        <p>Just sign in and navigate to the dashboard.</p>
                    </div>

                    {/* Sign In Button */}
                    <INCSUBButton text='Sign In' clickFun={handleLogin} />
                </div>
            </div>
        </div>
    );
}

export default INCSUBHomeScreen;
